import React from 'react';
import PropTypes from 'prop-types';

const badgeStyle = { position: 'relative' };
const Badge = ({ count, className }) =>
  count ? (
    <span style={badgeStyle} className={className}>
      <span className='badge-notification responsive-display-2-1 circle'>{count}</span>
    </span>
  ) : null;

Badge.defaultProps = {
  count: null,
  className: null
};

Badge.propTypes = {
  count: PropTypes.number,
  className: PropTypes.string
};

export default Badge;
